import { StyleSheet, Platform } from 'react-native';

import { Fonts, Colors, Types } from '../Themes';

export default StyleSheet.create({
  containerStyle: {
    marginBottom: Platform.OS === 'android' ? 30 : 12,
    paddingHorizontal: 16,
    paddingTop: 20,
  },
  gradientStyle: {
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    height: '100%',
  },
  headerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: 16,
  },
  backButtonAndTitleContainer: {
    flexDirection: 'row',
  },
  centerHeaderView: {
    flex: 1,
  },
  modalStyle: {
    margin: 0, // default modal has margins
    shadowColor: Colors.dark_grey,
    shadowOffset: { height: -2 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
  },
  titleStyle: (type, theme) => ({
    color: type === Types.SECONDARY ? theme.colors.headerTitleColor : Colors.white,
    fontFamily: Fonts.type.bold.fontFamily,
    ...Platform.select({
      android: {},
      ios: { fontWeight: 'bold' },
    }),
    fontSize: 16.6,
    letterSpacing: -0.27,
    textAlignVertical: 'center',
  }),
  touchableOpacityStyle: {
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  upperDash: {
    alignSelf: 'center',
    borderColor: Colors.brownGreyTwo,
    borderRadius: 10,
    borderStyle: 'solid',
    borderWidth: 2,
    marginBottom: 5,
    width: 36,
  },
  scrollViewContentContainer: {
    paddingBottom: 60,
  },
  backButtonIcon: {
    marginRight: 16,
  },
});
